import { FocusTrap } from '@/utils/focustrap';

export class Menu {
  constructor(menuElement, menuType, items = [], firstFocusableElement) {
    this.menuId = menuElement.id;
    this.menuType = menuType;
    this.navItems = items;
    this.firstFocusableElement = firstFocusableElement;
    this.currentItem = firstFocusableElement ?? 0;
    this.menuElement = menuElement;
    this.ulElement = menuElement.querySelector('ul');
    this.focusTrap =
      menuType !== 'main-menu'
        ? new FocusTrap({
            trapElement: menuElement,
            autofocus: false,
          })
        : null;
  }

  nextItem() {
    this.currentItem++;
    return this.navItems[(this.currentItem %= this.navItems.length)];
  }

  prevItem() {
    return this.navItems[(this.currentItem = --this.currentItem == -1 ? this.navItems.length - 1 : this.currentItem)];
  }

  getCurrentItem() {
    return this.navItems[this.currentItem];
  }

  resetMenu() {
    this.currentItem = this.firstFocusableElement ?? 0;
    this.focusTrap?.deactivate();
  }
}
export class MenuItem {
  constructor(element, nestedMenu = null) {
    this.id = element.id;
    this.text = element.textContent.trim();
    this.element = element;
    this.nestedMenu = nestedMenu;
    this.controls = element.getAttribute('data-menu-id') ?? element.getAttribute('aria-controls');
  }
}
